import React from 'react';
import { FaPrint } from 'react-icons/fa';

import './styles.css';

export default function StudentDocumentsCardItem(props) {
    return (
        <>
            <li className='student-card-payments-list-item'>
                <div>
                    <div>
                        <p className='tittle'><b>Data:</b> {props.date}</p>
                    </div>

                    {
                        props.scholarship ?
                            <span className='tag blue'>BOLSA</span>
                            : null
                    }

                    <span className='tag'>{props.parcel}</span>
                    <span className='tag green'>{props.dateRef}</span>
                </div>

                <button type='button' className='print' onClick={props.savePaymentReceiptPDF}><FaPrint /></button>
            </li>
        </>
    )
}